export default __webpack_public_path__ + "88da17c21cda7ac92bd913a6b789557a.webp";